import { RECEIVE_USER_FILES, REQUEST_USER_FILES } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: null,
        items: [],
    },
    actions
) => {
    const { type, data } = actions

    switch (type) {
        case REQUEST_USER_FILES:
            return { ...state, isFetching: true }

        case RECEIVE_USER_FILES:
            return { ...state, ...data, isFetching: false }

        default:
            return state
    }
}
